import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { ButtonLink as LiquidityButtonLink } from '@c2fo/liquidity';

interface ButtonLinkProps extends Omit<React.ComponentProps<typeof LiquidityButtonLink>, 'as'> {
  to: string;
}

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => {
  const Component = LiquidityButtonLink as React.ComponentType<ButtonLinkProps & { as: typeof Link }>;
  return <Component {...props} ref={ref} as={Link} />;
});

ButtonLink.displayName = 'ButtonLink';
